// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1cSDj","topBottomGutter":"Layout_topBottomGutter__1tTT6"};